import Vue from 'vue'
import VueRouter from 'vue-router'
import BrochureLayout from '../layouts/BrochureLayout'
import DashboardLayout from '../layouts/DashboardLayout'
import SinglePageLayout from '../layouts/SinglePageLayout'
import Home from '../pages/brochure/Home.vue'
import About from '../pages/brochure/About.vue'
import Authentication from '../pages/brochure/Authentication.vue'
import Faq from '../pages/brochure/Faq.vue'
import Dashboard from '../pages/dashboard/Dashboard.vue'
import Account from '../pages/dashboard/Account.vue'
import AddressBook from '../pages/dashboard/AddressBook.vue'
import OrderForm from '../pages/dashboard/OrderForm.vue'
import Order from '../pages/dashboard/Order.vue'
import NotFound from '../pages/NotFound.vue'
import { Auth } from 'aws-amplify';
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: BrochureLayout,
    children: [{ path: '', component: Home, name: 'Home' }]
  },
  {
    path: '/about',
    component: BrochureLayout,
    children: [{ path: '', component: About }]
  },
  {
    path: '/faq',
    component: BrochureLayout,
    children: [{ path: '', component: Faq }]
  },
  {
    path: '/signup',
    component: SinglePageLayout,
    children: [{ path: '', component: Authentication, props: { authForm: 'signUp' } }],
    meta: { requiresVisitor: true },
  },
  {
    path: '/login',
    component: SinglePageLayout,
    children: [{ path: '', component: Authentication, props: { authForm: 'signIn' } }],
    meta: { requiresVisitor: true },
  },
  {
    path: '/reset-password',
    component: SinglePageLayout,
    children: [{ path: '', component: Authentication, props: { authForm: 'forgotPassword' } }],
    meta: { requiresVisitor: true },
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    children: [{ path: '', component: Dashboard }],
    meta: { requiresAuth: true }
  },
  {
    path: '/account',
    component: DashboardLayout,
    children: [{ path: '', component: Account }],
    meta: { requiresAuth: true }
  },
  {
    path: '/address-book',
    component: DashboardLayout,
    children: [{ path: '', component: AddressBook }],
    meta: { requiresAuth: true }
  },
  {
    // name required only when used with params in push (and props set to true)
    path: '/order/buy',
    component: SinglePageLayout,
    children: [{ path: '', component: OrderForm, props: { orderType: 'buy', orderFormView: 'edit' } }],
    meta: { requiresAuth: true }
  },
  {
    path: '/order/sell',
    component: SinglePageLayout,
    children: [{ path: '', component: OrderForm, props: { orderType: 'sell', orderFormView: 'edit' } }],
    meta: { requiresAuth: true }
  },
  {
    path: '/order/buy/:id',
    component: SinglePageLayout,
    children: [{ path: '', component: Order, props: { orderType: 'buy' } }],
    meta: { requiresAuth: true }
  },
  {
    path: '/order/sell/:id',
    component: SinglePageLayout,
    children: [{ path: '', component: Order, props: { orderType: 'sell' } }],
    meta: { requiresAuth: true }
  },
  {
    path: '/:catchAll(.*)',
    component: SinglePageLayout,
    children: [{ path: '', component: NotFound, name: 'NotFound' }]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // const isAuthenticated = store.getters['auth/user']
  const isAuthenticated = await Auth.currentUserInfo()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresVisitor = to.matched.some(record => record.meta.requiresVisitor)

  if (requiresAuth && !isAuthenticated) next('/login')
  else next()
    
  if (requiresVisitor && isAuthenticated) next('/dashboard') 
  else next()
})

export default router
